import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function MobileMenu({anchorEl, open, sections, onClose, onNavigate, onLogout}) {
  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      {sections.map((section) => (
        <Box key={section.title} sx={{minWidth: 220}}>
          <MenuItem
            disabled
            sx={{
              opacity: 1,
              fontWeight: 600,
              pointerEvents: 'none',
              color: 'text.primary',
            }}
          >
            {section.title}
          </MenuItem>
          {section.items.map((item) => (
            <React.Fragment key={item.path || item.label}>
              <MenuItem onClick={() => item.path && onNavigate(item.path)} disabled={!item.path}>
                {item.label}
              </MenuItem>
              {item.children?.map((child) => (
                <MenuItem key={child.path} onClick={() => onNavigate(child.path)} sx={{pl: 3}}>
                  {child.label}
                </MenuItem>
              ))}
            </React.Fragment>
          ))}
        </Box>
      ))}
      <MenuItem onClick={onLogout} color="inherit">
        Logout
      </MenuItem>
    </Menu>
  );
}
